// extracted by mini-css-extract-plugin
module.exports = {"root":"NAPagExhksqS0nE42y1o","image":"hcPnfqVxRc6LRDMt4XMU","link":"X8pC9I0ok0p8EF4yxRdk"};